import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  getTropicalDiseasePurchaseData: state =>
    qoalaStorage.getItem('tropicalDiseasePurchaseData')
      ? parseIfJsonString(qoalaStorage.getItem('tropicalDiseasePurchaseData'))
      : state.tropicalDiseasePurchaseData,
  getProductDetail: state =>
    qoalaStorage.getItem('tropicalDiseaseProductDetail')
      ? parseIfJsonString(qoalaStorage.getItem('tropicalDiseaseProductDetail'))
      : state.productDetail || {},
  getListProduct: state =>
    qoalaStorage.getItem('tropicalDiseaseProduct')
      ? parseIfJsonString(qoalaStorage.getItem('tropicalDiseaseProduct'))
      : state.listProduct || [],
  getClaims: state => {
    if (!state.claims) {
      return '';
    }
    if (state.claims === 'undefined') {
      return '';
    }
    if (typeof state.claims === 'string') {
      return JSON.parse(state.claims);
    }
    return state.claims;
  }
};
